import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { FileX2 } from 'lucide-react';
export function PainSection() {
  return <section className="py-24 relative bg-navy-950" data-id="element-150">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-151">
        <FadeIn data-id="element-152">
          <div className="w-16 h-16 mx-auto mb-8 rounded-full bg-navy-800 border border-navy-700 flex items-center justify-center" data-id="element-153">
            <FileX2 className="w-8 h-8 text-gold-500/70" data-id="element-154" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-155">
          <h2 className="text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-156">
            No es tu falta de dinero, es su{' '}
            <span className="text-gold-400" data-id="element-157">falta de respeto.</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-158">
          <div className="relative" data-id="element-159">
            <span className="absolute -top-10 -left-6 text-8xl text-navy-800 font-serif select-none" data-id="element-160">
              "
            </span>
            <p className="text-xl md:text-2xl text-gray-300 leading-relaxed font-light relative z-10" data-id="element-161">
              Nada duele más que trabajar 60 horas a la semana, tener el dinero
              en la mano y que un empleado de 20 años detrás de un escritorio te
              diga: "Lo sentimos, no califica".
              <br data-id="element-162" />
              <br data-id="element-163" />
              No eres tú, es tu código financiero el que está roto. En USA, no
              eres lo que trabajas, eres lo que tu reporte dice de ti. Es hora
              de dejar de pedir permiso y empezar a exigir espacio.
            </p>
            <span className="absolute -bottom-16 -right-6 text-8xl text-navy-800 font-serif select-none rotate-180" data-id="element-164">
              "
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}